import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()

export function authHeader() {
    // return authorization header with jwt token

    if (
        history.location.pathname !== '/auth/login' &&
        history.location.pathname !== '/confirmToken' &&
        history.location.pathname !== '/resetPassword' &&
        history.location.pathname !== '/confirmRegistration' &&
        history.location.pathname !== '/register'
    ) {
        let user = JSON.parse(localStorage.getItem('user'));
        let token = localStorage.getItem('token');
        if (user && token) {
            return { 'Authorization': 'Bearer ' + token };
        } else {
            return {};
        }
    }
}